module.exports = __webpack_public_path__ + "static/media/icon-webpage-video.455810a2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/features/icon-webpage-video.mp4
// module id = 1882
// module chunks = 1